export default "__VITE_ASSET__099451f0__"